<template lang="pug">
.bg-light
  .login
    .login-form.d-flex.justify-content-center(
      v-if="loginInfomation.photo",
      :style="{ backgroundImage: 'url(' + loginInfomation.photo.image + ')' }"
    )
      .py-5.col-md-9
        form.bg-white(@submit="submitForm")
          h3.text-white.bg-dark.px-4.py-3.mb-3 EETI Member Sign In
          .form-group.mb-3.px-4.pt-2
            label(for="exampleInputEmail1") Email addres:
            input#exampleInputEmail1.form-control(
              type="email",
              aria-describedby="emailHelp",
              v-model="email",
              :class="{ 'is-invalid': emailCheck }"
            )
            #validationServer03Feedback.invalid-feedback
              | {{ emailCheckMsg }}
          .form-group.mb-1.px-4
            label(for="exampleInputPassword1") Password:
            input#exampleInputPassword1.form-control(
              type="password",
              v-model="password",
              :class="{ 'is-invalid': passwordCheck }"
            )
            #validationServer03Feedback.invalid-feedback
              | {{ passwordCheckMsg }}
            .invalid-feedback.d-block(v-if="serverMessageCheck") {{ serverMessage }}
          .form-group.mb-3.px-4
            small
              a(
                style="cursor: pointer",
                v-b-modal.forgotPasswordModal="",
                @click="$bvModal.show('forgotPasswordModal')",
                data-toggle="modal",
                data-target="#forgotPasswordModal"
              ) Forget Password?
          .form-group.mb-1.px-4
            small not our member ?
          .form-group.form-check.m1-3.px-4
            .custom-control.custom-checkbox.mr-sm-2
              input#customControlAutosizing.custom-control-input(
                type="checkbox",
                v-model="remember"
              )
              label.custom-control-label(for="customControlAutosizing") Remember me on this device.
          .form-group.mb-2.px-4
            button.btn.btn-warning.px-4(type="submit") Sign In
          .form-group.mb-2.px-4.pb-4
            a.underline(href="/register") Register for an account
    .login-text.py-4.d-flex.justify-content-center
      .col-md-11.pt-2
        h2 Why Register for EETI Portal ?
        p.pr-5
          | Join EETI Portal and get access to member exclusive benefits wish Constant technical support and update solution service.
        h3 EETI Member Benefits Include:
        .row.row-sm.benefits.my-3.text-center
          .col-6.col-md-3(
            v-for="(benefit, index) in benefits",
            :key="index",
            :class="[index < 4 ? 'my-2' : 'my-3']"
          )
            benefit(:title="benefit.title", :icon="benefit.icon")
        a.btn.btn-warning.px-4(href="/memberportal") Get Design Support
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer 
  dialog-text-btn(
    @onDialogTextBtnClick="onDialogTextBtnClick",
    :title="dialogTextBtnData.title",
    :content="dialogTextBtnData.content",
    :btn="dialogTextBtnData.btn"
  )
  dialog-forgot-password(
    @onSendPasswordSuccess="onSendPasswordSuccess",
    @onSendPasswordFail="onSendPasswordFail"
  )
  dialog-completed(:text="sendPasswordText")
</template>

<script>
import { mapActions } from "vuex";
import Benefit from "@/components/login/Benefit";
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import { getAccount, setAccount, removeAccount } from "@/utils/auth";
import DialogTextBtn from "@/components/common/DialogTextBtn";
import DialogForgotPassword from "@/components/common/DialogForgotPassword";
import DialogCompleted from "@/components/common/DialogCompleted";
import { getLoginInformation } from "@/api/login";

export default {
  name: "Login",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    benefit: Benefit,
    DialogTextBtn,
    DialogForgotPassword,
    DialogCompleted,
  },
  data() {
    return {
      loginInfomation: {},
      sendPasswordText: "",

      email: "",
      password: "",
      remember: false,

      emailCheck: false,
      emailCheckMsg: "Please provide a valid Email.",
      passwordCheck: false,
      passwordCheckMsg: "Please provide a valid Password.",
      serverMessage: "",
      serverMessageCheck: false,

      dialogTextBtnData: {
        title: "Error",
        content: "User has not been activated.",
        btn: "Send Auth",
      },

      benefits: [
        {
          title: "Technical Support",
          icon: require("@/assets/img/login/login-1.png"),
        },
        {
          title: "Touch Manager plus",
          icon: require("@/assets/img/login/login-2.png"),
        },
        {
          title: "Start a new project",
          icon: require("@/assets/img/login/login-3.png"),
        },
        {
          title: "API Notes",
          icon: require("@/assets/img/login/login-4.png"),
        },
        {
          title: "Data Sheets",
          icon: require("@/assets/img/login/login-5.png"),
        },
        {
          title: "Programming guide",
          icon: require("@/assets/img/login/login-6.png"),
        },
        {
          title: "Apply work shop",
          icon: require("@/assets/img/login/login-7.png"),
        },
        {
          title: "FAQ",
          icon: require("@/assets/img/login/login-8.png"),
        },
      ],

      metaData: {
        title: "Login In ｜EETI member benefit",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    if (getAccount() && getAccount() != "") {
      this.email = getAccount();
      this.remember = true;
    }
    this.initialLanguage();
  },
  methods: {
    ...mapActions("user", ["login"]),
    initialLanguage() {
      this.getLoginInformation();
    },
    submitForm(e) {
      e.preventDefault();
      this.serverMessage = "";
      this.serverMessageCheck = false;

      if (this.email == "") {
        this.emailCheck = true;
      } else {
        this.emailCheck = false;
      }

      if (this.password == "") {
        this.passwordCheck = true;
      } else {
        this.passwordCheck = false;
      }

      if (this.emailCheck || this.passwordCheck) {
        return;
      }

      let inputData = {
        email: this.email,
        password: this.password,
      };

      this.login(inputData)
        .then(() => {
          if (this.remember) {
            setAccount(this.email);
          } else {
            removeAccount();
          }
          this.$router.push({ name: "MemberPortal" });
        })
        .catch((error) => {
          removeAccount();
          if (error.response.data.activation_error) {
            this.showTextBtnDialog();
          } else {
            this.serverMessage = error.response.data.error;
            this.serverMessageCheck = true;
          }
        });
    },
    showTextBtnDialog() {
      this.$bvModal.show("textBtnModal");
    },
    onDialogTextBtnClick() {
      this.$bvModal.hide("textBtnModal");
      this.$router.push({ name: "SendAuth" });
    },
    onSendPasswordSuccess(email) {
      this.sendPasswordText =
        "We have sent a reset password email to " +
        email +
        ". Please click the reset password link to set your new password.";

      this.$bvModal.show("completedModal");
    },
    onSendPasswordFail() {
      this.sendPasswordText =
        "Your search did not return any results. Please try again with other information.";
      this.$bvModal.show("completedModal");
    },
    getLoginInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getLoginInformation(temp).then((response) => {
        this.loginInfomation = response.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/style/login/login";
</style>
